var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g(_vm._b({class:_vm.$style.root,attrs:{"vusion-slot-name-edit":"text"}},'span',_vm.$attrs,false),_vm.$listeners),[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }